import React from 'react';
import CategoriesAndLinks from './Components/CategoriesAndLinks';

 import './AffiliateLinks.css'
import BulletPointsAndLinks from './Components/BulletPointsAndLinks';

// Define a functional component named MyComponent
function AffiliateLinks() {
    const bathroomLinks = [
        {display:"Aquasana Shower filter", url:"https://amzn.to/4ogJQRV"},
        {url:"https://amzn.to/4qychw0", display:"Amazon 100% Bamboo toilet paper- no dyes or chlorine"},
        {url:"https://amzn.to/47RQozx" , display:"100% Organi cotton bath towel set (6 colors)"},
        {url:"https://amzn.to/47A33H5" , display:"Cute textured organic cotton towel set (13 color options)"},
        {url:"https://amzn.to/4nqgsY0" , display:"Quick drying stone bath mat"},
        {url:"https://amzn.to/4nv7OHT" , display:"100% cotton shower curtain liner"},
        {url:"https://amzn.to/43Jb2jN" , display:"Branch Basics bathroom cleaner"},
        {url:"https://amzn.to/3KnVCLs" , display:"Filterbaby Sink Filter"},
        {url:"https://amzn.to/3WsKrnm" , display:"Terra Manuka honey baby wipes"}, 
        {url:"https://amzn.to/4a08u3a" , display:"Boar Bristle Plastic Free Toothbrush pack"}, 
        {url:"https://amzn.to/49YCwWN" , display:"DrTung's Smart PFA Free Floss"}, 
        {url:"https://amzn.to/48vc9VO" , display:"Himalaya Botanique Flouride Free Toothpaste"}, 
        {url:"https://amzn.to/3KMoXiQ" , display:"Olas Alcohol Free Mouthwash"}, 
        {url:"https://amzn.to/3XJwXnI" , display:"100% Cotton Face Tissues"}, 
        {url:"https://amzn.to/4pRJn90" , display:"Reel fragrance-free, chlorine-free, dye free, plastic free toilet paper"}, 
        {url:"https://amzn.to/4plMlCQ" , display:"Bambaw Stainless Steel Razor"}, 

    ]
    
    const bedroomLinks = [
        
        {url:"https://amzn.to/3KMp2mE", display:"Airdoctor Air Filter"},
        {url:"https://amzn.to/4o0GocX", display:"100% Organic coton sheet set"},
        {url:"https://amzn.to/4o7OIZr", display:"Puredown goose  feathers and down white pillows w/ 100% organic cotton cover"},
        {url:"https://amzn.to/4hu70By", display:"Cute wool rug"},
        {url:"https://amzn.to/3LMVVjm", display:"100% Organic Cotton All Season Down Feather Comforter"},
        {url:"https://amzn.to/4rGi82V", display:"VIVITEST Aromatherapy Diffuser"},
    ] 
 const laundryroomLinks = [
        {url:"https://amzn.to/3L4ViBt", display:"Mollys Suds laundry detergent powder"},
        {url:"https://amzn.to/48H7x05", display:"Mollys Suds laundry detergent pods"},
        {url:"https://amzn.to/4rzovVS", display:"Mollys Suds laundry detergent liquid"},
        {url:"https://amzn.to/43yy7pi", display:"Branch Basics laundry detergent"},
        {url:"https://amzn.to/4nvJ9CN", display:"Organic wool dryer balls"},
        {url:"https://amzn.to/43D5qaP", display:"Mollys Suds laundry machine cleaner"},
    ] 
 const NonToxCleanersLinks = [
        {url:"https://amzn.to/4tQwgYG", display:"Branch Basics Cleaning Essentials Kit"},
        {url:"https://amzn.to/4qxkvn7", display:"Zum All Purpose Cleaner"},
        {url:"https://amzn.to/4asazVL", display:"Mollys Suds Toilet Bowl Cleaner"},
        {url:"https://amzn.to/4tA8NdZ", display:"Koala Eco Floor Cleaner"},
    ] 
const MedicineLinks = [
        {url:"https://amzn.to/48Tlbxn", display:"Boiron Cold Medicine"},
        {url:"https://amzn.to/3MmzZfc", display:"Boiron Oscillococcinum for Relief from Flu-Like Symptoms"},
        {url:"https://amzn.to/4iMEGuW", display:"Boiron Homeopathic Medicine for Fever"},
        {url:"https://amzn.to/3KwV4Dc", display:"Boiron Homeopathic Cough Medicine"},
        {url:"https://amzn.to/4aBB4d4", display:"Boiron Homeopathic Menstrual Cramp Relief Medicine"},
        {url:"https://amzn.to/4rY1Cvw", display:"Boiron Homeopathic Medicine for Relief from Muscle Pain, Muscle Stiffness, Swelling from Injury"},
        {url:"https://amzn.to/3MKYL8N", display:"Badger Aromatic Chest Rub"},
        {url:"https://amzn.to/492JYhB", display:"Boiron Homeopathic Medicine for Headaches"},
        {url:"https://amzn.to/48EXh7E", display:"PURE SYNERGY Rapid Rescue | Organic Immune Support Capsules"},
        {url:"https://amzn.to/44TCRq6", display:"For Kids-Earthley Wellness Teeth Tamer, Teething Relief for Babies & Kids"},
        {url:"https://amzn.to/4pmogvz", display:"For Kids-Boiron Homeopathic Medicine Relief from Fever, Hot and Dry Skin, Cough, and Restlessness"},
        {url:"https://amzn.to/44MpfNr", display:"For Kids-Boiron AllergyCalm Kids Tablets for Relief from Allergy and Hay Fever Symptoms"},
        {url:"https://amzn.to/4aD2Tlb", display:"For Kids-Boiron ColdCalm Baby Single-Use Drops for Relief from Cold Symptoms"},
        {url:"https://amzn.to/4pOqYtI", display:"For Kids-Earthley Wellness, Cough-B-Gone, Alcohol-Free Herbal Tincture for Kids & Adults (6 Months+)"},
        {url:"https://amzn.to/3XCsBie", display:"FEBU PFAS Free Flexible Fabric Bandaids"},
    ] 
    const SnackLinks = [
        {url:"https://amzn.to/45Csyr0", display:"Skout Organic Soft Baked Cookie Variety Pack"},
        {url:"https://amzn.to/4q5EJ76", display:"CauliPuffs Puffed Snack"},
        {url:"https://amzn.to/4blJ7Lz", display:"Siete Dip Tortilla Chips"},
        {url:"https://amzn.to/4kaaY3B", display:"Siete Corn Tortilla Chips"},
        {url:"https://amzn.to/3ZH8BvG", display:"Siete Blue Corn Tortilla Chips"},
        {url:"https://amzn.to/466M532", display:"Jackson's Potato Classic Kettle Chips"},
        {url:"https://amzn.to/4qMtMIC", display:"Jackson's Sweet Potato Kettle Chips"},
        {url:"https://amzn.to/49MwBDI", display:"Unique Snacks Organic Sprouted Splits Pretzels"},
        {url:"https://amzn.to/4rjslkR", display:"Unique Snacks Organic Sprouted Pretzel Shells"},
        {url:"https://amzn.to/4q3249l", display:"Simple Mills Honey Cinnamon Seed & Nut Flour Sweet Thins"},
        {url:"https://amzn.to/4k8slBN", display:"Simple Mills, Cocoa Cashew Crème Sandwich Cookies"},
        {url:"https://amzn.to/4rojGO9", display:"Simple Mills Almond Flour Toasted Pecan Cookies"},
        {url:"https://amzn.to/3M74lCu", display:"Simple Mills Chocolate Brownie Seed & Nut Flour Sweet Thins"},
        {url:"https://amzn.to/4rkyhKv", display:"PRIMA ANCESTRAL PROTEIN BAR"},
        
        
        
    ] 

    const getLiLink = (url, display, key="") => {
        return <li key={key}><a href={url} target="_blank" rel="noreferrer">{display}</a></li>
    }
    const beautyEssentialsBulletPointsAndLinks = [
        {
            bulletPoint: "Face/Hair/Body Care/Makeup/Perfume/Deoderant", 
            links: [
                {url:"https://amzn.to/3K9hvy7", display:"BeeFriendly Organic Facial Moisturizer"},
                {url:"https://amzn.to/48CNGza", display:"Carina Organics Unscented Daily Moisturizer"},
                {url:"https://amzn.to/48q5w8I", display:"DIME Beauty Dewy Day Cream Face Moisturizer "},
                {url:"https://amzn.to/3KhyEFR", display:"Aleavia Purifying Facial Cleanse"},
                {url:"https://amzn.to/4rlgVxM", display:"Ogee Botanical Brilliance Exfoliating Cleanser"},
                {url:"https://amzn.to/3Xa1jiX", display:"Lily Lolo All-Natural Mascara"},
                {url:"https://amzn.to/3JKxKBB", display:"Lily Lolo Mineral Blush"},
                {url:"https://amzn.to/3JNBNNv", display:"Lily Lolo Lip Gloss"},
                {url:"https://amzn.to/4psS2P0", display:"WellPeople Complexion Stick"},
                {url:"https://amzn.to/4roIzdi", display:"RMS Beauty Go Nude Lip Pencil"},
                {url:"https://amzn.to/4ai7R6P", display:"RMS Beauty Redimension Hydra Powder Blush"},
                {url:"https://amzn.to/3LZ7vYR", display:"Ogee Sculpted Complexion Foundation Stick"},
                {url:"https://amzn.to/4rlfi38", display:"DIME Beauty 7 Summers Perfume"},
                {url:"https://amzn.to/3XYx3rv", display:"DIME Beauty Malibu Nights Perfume"},
                {url:"https://amzn.to/485hrbS", display:"DIME Beauty Perfume I Love Your Smell, Baby"},
                {url:"https://amzn.to/4rsTSS0", display:"HUMBLE Original Formula Aluminum-free Deodorant"},
                {url:"https://amzn.to/4pTADiX", display:"Each & Every Aluminum Free Deodorant"},
                {url:"https://amzn.to/48E3JvD", display:"Aleavia Body Wash"},
                {url:"https://amzn.to/4aHNC2u", display:"Rahua Shower Gel"},
                {url:"https://amzn.to/3YfDYNa", display:"Carina Organics Body Wash"},
                {url:"https://amzn.to/4pvy1YH", display:"Hooga Red Light Therapy Panel for Face and Body"},

            ]
        },

           {
            bulletPoint: "Hair Care", 
            links: [
                 {url:"https://amzn.to/48nkZWO" , display:"Rahua Classic Hair Shampoo"}, 
                 {url:"https://amzn.to/4oOZaVV" , display:"Rahua Classic Hair Conditioner"}, 
                 {url:"https://amzn.to/3X6KmpI" , display:"Carina Organics Shampoo"}, 
                 {url:"https://amzn.to/4oPPtXn" , display:"Carina Organics Conditioner"}, 
            ]
        },

         {
            bulletPoint: "Feminine Products", 
            links: [
                {url:"https://amzn.to/3Xkpyew", display:"LOLA Panty Liners - Ultra-Thin"},
                {url:"https://amzn.to/3Kt9SCF", display:"Natracare Organic Cotton Regular Tampons"},
                {url:"https://amzn.to/4p3zJAf", display:"Natracare Slim Fitting Ultra Pads"},
                {url:"https://amzn.to/3M0IU5W", display:"LOLA Organic Tampons - Regular"},
            ]
        },

          {
            bulletPoint: "Low Tox Clothing", 
            links: [
                {url:"https://amzn.to/4852Ltl", display:"Oversized Cotton Sweater"},
                {url:"https://amzn.to/48hX9L0", display:"Women's Sweater 100% Cotton"},
                {url:"https://amzn.to/4rjie0p", display:"Womens 100% Wool Sweater"},
                {url:"https://amzn.to/3KnY9oW", display:"V Neck Womens 100% Wool Sweater"},
                {url:"https://amzn.to/4rnyixX", display:"100% Cotton Pajama Set"},
                {url:"https://amzn.to/4itX3EY", display:"Womens Cotton Bra Set"},
                {url:"https://amzn.to/4rt5OmI", display:"Womens Cotton Underwear 6 pack"},
                {url:"https://amzn.to/3MoZRqE", display:"Womens Cotton No Show Socks"},
                {url:"https://amzn.to/48I3910", display:"Pact Women's Organic Cotton Underwear"},
                {url:"https://amzn.to/4irYCD3", display:"Pact Organic Cotton Women's Stretch Denim Jacket"},
                {url:"https://amzn.to/48vKlkt", display:"Pact Women's Organic Cotton Go-to Legging"},
                 {url:"https://amzn.to/49Uxevv", display:"100% Organic Cotton Shorts for Women"},
            ]
        },   
       
    ]
  return (
    <div className="container">
        <img src="images/leaf.jpeg" alt="Leaf Background" id="leaf-backgroung-img"></img>
        <img src="images/surfboard.png" alt="Leaf Background" id="surfboard-img"></img>
        <h2 className="text-center" id="top-logo">Shore Roots Holistic</h2>
        <h1 className="text-center" id="main-header">Non Tox/ Low Tox Swaps For Your Home</h1>
        <BulletPointsAndLinks category='Beauty Essentials and Clothing' bulletPointsAndLinks={beautyEssentialsBulletPointsAndLinks}  />
        <h2>Kitchen Essentials</h2>
        <ul>
            <li className='list-with-padding-bottom'>
                <h3 className="header-one">Water Filters</h3>
             
                <ul>
                    {getLiLink("https://amzn.to/47rmba6", "Aquatru under the sink filter")}
                    {getLiLink("https://amzn.to/47cXM9p", "Aquatru  countertop filter")}
                </ul>
            </li>
             <li>
                <h3 className="header-one">Non Toxic Cookware/Bakeware/Drinking Glasses/Dish Detergent/Dish Brushes</h3>
                <ul>
                    {getLiLink("https://amzn.to/4oaOsIl", "Caraway Non-stick Ceramic Cookware Set")}
                    {getLiLink("https://amzn.to/4r40qWZ", "Le Creuset Enameled Cast Iron Cookware Set, 5 pc")}
                    {getLiLink("https://amzn.to/482Pjoq", "Caraway 14-Piece Kitchen Prep Set - Kitchen Knife Set & Wooden Utensil Set")}
                    {getLiLink("https://amzn.to/4og2pVC", "Caraway Nonstick Ceramic Bakeware Set (11 Pieces)")}
                    {getLiLink("https://amzn.to/4oWuzWO", "Stainless Steel Kitchen Utensils Set - 12 PCS")}
                    {getLiLink("https://amzn.to/4ituaJ3", "Stainless Steel Mixing Bowl Set")}
                    {getLiLink("https://amzn.to/4p2kAiI", "Ribbed Glass Tumbler(4 pcs) with Straw and Lid")}
                    {getLiLink("https://amzn.to/3KeqzSl", "Molly's Suds Liquid Dish Soap")}
                    {getLiLink("https://amzn.to/4rpw7u1", "Molly's Suds Dish Detergent Pods")}
                    {getLiLink("https://amzn.to/48N3XRf", "Branch Basics Dishwasher Tablets")}
                    {getLiLink("https://amzn.to/4pslMMv","100% Plastic Free Bamboo Dish Brush Set")}

                    
                </ul>
            </li>
        
        </ul>
        <CategoriesAndLinks category="Bathroom Essentials" links={bathroomLinks} />
        <CategoriesAndLinks category="Bedroom Essentials" links={bedroomLinks} />
        <CategoriesAndLinks category="Laundry Room Essentials" links={laundryroomLinks} />
        <CategoriesAndLinks category="Non Toxic Household Cleaners" links={NonToxCleanersLinks} />
        <CategoriesAndLinks category="Natural Medicine Essentials Adults & Children" links={MedicineLinks} />
         <CategoriesAndLinks category="Healthy Snacks/Protein Bars" links={SnackLinks} />

    </div>
  );
}

// Export the component so it can be used in other files
export default AffiliateLinks;